(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sr-collection-price-assets"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.srCollectionPriceReady) return;
  window.srCollectionPriceReady = true;
  let timer;
  const refresh = () => {
    clearTimeout(timer);
    let next = Infinity;
    document.querySelectorAll('[data-sr-collection-price][data-promotional="true"]').forEach(card => {
      const expiry = Number(card.dataset.expiry) * 1000;
      if (!Number.isFinite(expiry) || expiry <= Date.now()) {
        const base = card.querySelector('[data-sr-collection-base]');
        const effective = card.querySelector('[data-sr-collection-effective]');
        if (base && effective) effective.textContent = base.content.textContent;
        card.querySelectorAll('[data-sr-collection-promotion]').forEach(node => { node.hidden = true; });
        card.querySelectorAll('[data-sr-collection-sale]').forEach(node => { node.hidden = false; });
        card.dataset.promotional = 'false';
      } else next = Math.min(next, expiry);
    });
    if (Number.isFinite(next)) timer = setTimeout(refresh, Math.min(next - Date.now() + 100, 2147483647));
  };
  const start = () => {
    refresh();
    // Native grids currently navigate for filters/sorting; also cover section replacement.
    new MutationObserver(records => {
      if (records.some(record => Array.from(record.addedNodes).some(node =>
        node.nodeType === 1 && (node.matches('[data-sr-collection-price]') || node.querySelector('[data-sr-collection-price]'))
      ))) refresh();
    }).observe(document.getElementById('MainContent') || document.body, {childList:true,subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  document.addEventListener('shopify:section:load', refresh);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sr-cro-purchase-state"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => document.querySelectorAll('[data-sr-cro] form[action*="/cart/add"]').forEach(form => {
    if (form.dataset.srPurchaseStateReady) return;
    form.dataset.srPurchaseStateReady = 'true';
    const hero = form.closest('[data-sr-cro]');
    const buttons = hero.querySelectorAll('[data-sr-add],[data-sr-bph-main-add],[data-sr-sticky-add],[data-sr-bph-sticky-add]');
    const reset = () => {
      form.removeAttribute('aria-busy');
      buttons.forEach(button => button.removeAttribute('aria-busy'));
    };
    form.addEventListener('submit', event => {
      if (event.defaultPrevented) return;
      if (form.getAttribute('aria-busy') === 'true') { event.preventDefault(); return; }
      form.setAttribute('aria-busy', 'true');
      buttons.forEach(button => button.setAttribute('aria-busy', 'true'));
      // Native Shopify submission continues. No cart request or click forwarding here.
    });
    form.addEventListener('invalid', reset, true);
    window.addEventListener('pageshow', reset);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

})();
